import { render } from "./Register.vue?vue&type=template&id=93dcfc12&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=93dcfc12&scoped=true&lang=scss"
import "./Register.vue?vue&type=style&index=1&id=93dcfc12&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93dcfc12"]])

export default __exports__